import SortingAndFiltering from './SortingAndFiltering';

export default SortingAndFiltering;
